import { Controller } from "stimulus"

export default class FlashController extends Controller {
  static targets = ["message"]
  initialize() {
    const targets = this.messageTargets;

    targets.forEach((target) => {
      let message = target.getAttribute('content');
      if (message == null) { return; }
      let type = target.getAttribute('type');
      if (type == null) { return; }
      toastr[type](message);
    })
  }
}
